document.documentElement.classList.remove('no-js');

function burstFormatMoney(cents, format) {
  const value = (Number(cents || 0) / 100).toFixed(2);
  const noDecimals = Math.round(Number(cents || 0) / 100).toString();
  const template = format || '${{amount}}';
  return template
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
    .replace(/\{\{\s*amount\s*\}\}/g, value);
}


// V2.6.13: Independent image swatches for HighlandHugs Style and Free Outfit.
// Uses explicit per-option CDN images; does not depend on 78 combination featured images.
function burstHHShowOptionImage(choice) {
  if (!choice || !choice.dataset.hhImageUrl) return;
  const gallery = document.querySelector('[data-hh-cow-gallery]');
  if (!gallery) return;
  const url = choice.dataset.hhImageUrl;
  const file = decodeURIComponent(url.split('/').pop().split('?')[0]);
  const stem = file.replace(/\.[^.]+$/, '');
  const slides = [...gallery.querySelectorAll('[data-v23-slide]')];
  let slide = slides.find(el => {
    const img = el.querySelector('img');
    if (!img) return false;
    return [img.getAttribute('src'), img.currentSrc, img.src, img.getAttribute('srcset')].filter(Boolean).some(v => decodeURIComponent(v).includes(stem));
  });
  // Fallback if an option image was not added to Shopify's product media.
  if (!slide) {
    slide = gallery.querySelector('[data-hh-preview-slide]');
    if (!slide) {
      slide = document.createElement('div');
      slide.className = 'v23-media-slide';
      slide.dataset.v23Slide = 'hh-option-preview';
      slide.dataset.hhPreviewSlide = '';
      slide.innerHTML = '<img class="v23-product-image" alt="Selected option preview" loading="eager">';
      gallery.querySelector('[data-v23-mobile-track]')?.appendChild(slide);
    }
    slide.querySelector('img').src = url;
    slide.querySelector('img').alt = choice.dataset.optionValue || 'Selected option';
  }
  gallery.querySelectorAll('[data-v23-slide]').forEach(el => el.classList.toggle('is-active',el===slide));
  const id = String(slide.dataset.v23Slide);
  gallery.querySelectorAll('[data-v23-thumb]').forEach(el=>el.classList.toggle('is-active',el.dataset.v23Thumb===id));
  gallery.querySelectorAll('[data-v23-dot]').forEach(el=>el.classList.toggle('is-active',el.dataset.v23Dot===id));
  const sticky = document.querySelector('[data-sticky-image]');
  if (sticky) sticky.src = url;
  const track = gallery.querySelector('[data-v23-mobile-track]');
  if (track && window.innerWidth < 750) track.scrollTo({left:slide.offsetLeft,behavior:'smooth'});
}

function burstVariantImage(variant) {
  if (!variant) return '';
  if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
  if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
  return '';
}


// Burst V2.6.3 — sync grouped option selections (including Model) to the V2.3 product gallery.
// Burst V2.6.7 — resolve media for multi-option products.
// Example: Color + Size where only one variant per color has a featured image.
// Size changes keep the selected color image; color changes still switch the gallery.
// V2.6.12: For HighlandHugs, map Style to 01-13 cow media, never to Free Outfit media.
function burstCowMediaForStyle(formWrap, variant) {
  const gallery = document.querySelector('[data-hh-cow-gallery]');
  if (!gallery || !variant) return null;
  const groups = Array.from(formWrap.querySelectorAll('[data-option-group]'));
  const styleIndex = groups.findIndex(g => /^(style|model)$/i.test((g.querySelector('[data-option-input]')?.name || g.getAttribute('data-option-name') || '').replace(/^options\[|\]$/g,'')));
  // This product's Style is the first option, Free Outfit the second.
  const value = variant.options && variant.options[styleIndex >= 0 ? styleIndex : 0];
  const styles = ['Cream','Mocha','Meirad','LeLe','QiQi','Ice','KaKa','Soft Pink','Cookie','Soda','Gray Bean','Cream Sandwich','Milk Coffee'];
  const n = styles.indexOf(value);
  if (n < 0) return null;
  const prefix = String(n + 1).padStart(2,'0') + (n === 12 ? '.' : '_');
  const slide = Array.from(gallery.querySelectorAll('[data-v23-slide]')).find(s => {
    const img = s.querySelector('img');
    const src = img?.getAttribute('src') || '';
    const filename = src.split('/').pop().split('?')[0];
    return filename.startsWith(prefix) || (n === 12 && filename.startsWith('13.'));
  });
  if (!slide) return null;
  return {featured_media:{id:slide.dataset.v23Slide},featured_image:{src:slide.querySelector('img')?.src || ''}};
}

function burstResolveVariantForMedia(formWrap, variants, variant) {
  if (!variant) return null;
  if (burstVariantImage(variant) || (variant.featured_media && variant.featured_media.id)) return variant;

  const visualGroup = formWrap?.querySelector('[data-v23-ui-option-group].is-visual');
  if (!visualGroup) return variant;
  const pos = Math.max(0, Number(visualGroup.dataset.optionPosition || 1) - 1);
  const visualValue = variant.options && variant.options[pos];
  if (!visualValue) return variant;

  return variants.find(v =>
    v.options && v.options[pos] === visualValue &&
    (burstVariantImage(v) || (v.featured_media && v.featured_media.id))
  ) || variant;
}

function burstSwitchV23GalleryToVariant(variant, scrollMobile=true) {
  if (!variant) return;
  const gallery = document.querySelector('[data-v23-gallery]');
  if (!gallery) return;
  const slides = Array.from(gallery.querySelectorAll('[data-v23-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-v23-thumb]'));
  const dots = Array.from(gallery.querySelectorAll('[data-v23-dot]'));
  const track = gallery.querySelector('[data-v23-mobile-track]');

  let mediaId = variant.featured_media && variant.featured_media.id ? String(variant.featured_media.id) : '';
  let target = mediaId ? slides.find(s => String(s.dataset.v23Slide) === mediaId) : null;

  // Shopify variant JSON may only expose featured_image.src. Match by normalized CDN path.
  if (!target) {
    const src = burstVariantImage(variant);
    if (src) {
      const clean = String(src).split('?')[0].replace(/^https?:/, '');
      target = slides.find(s => {
        const img = s.querySelector('img');
        if (!img) return false;
        const candidates = [img.currentSrc, img.src, img.getAttribute('src')].filter(Boolean);
        return candidates.some(v => String(v).split('?')[0].replace(/^https?:/, '') === clean || String(v).includes(clean));
      });
    }
  }

  if (!target) return;
  const id = String(target.dataset.v23Slide || '');
  slides.forEach(s => s.classList.toggle('is-active', s === target));
  thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.v23Thumb) === id));
  dots.forEach(d => d.classList.toggle('is-active', String(d.dataset.v23Dot) === id));

  if (window.innerWidth < 750 && scrollMobile && track) {
    track.scrollTo({left: target.offsetLeft, behavior:'smooth'});
  }
}

function burstSyncGroupedOptionPicker(formWrap, variants, selected, moneyFormat) {
  if (!formWrap) return;
  const choices = Array.from(formWrap.querySelectorAll('[data-v23-option-choice]'));
  choices.forEach(choice => {
    const pos = Math.max(0, Number(choice.dataset.optionPosition || 1) - 1);
    const value = choice.dataset.optionValue || '';
    const isSelected = selected[pos] === value;
    choice.classList.toggle('is-selected', isSelected);
    choice.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

    const candidates = variants.filter(v => v.options.every((opt, i) => i === pos ? opt === value : opt === selected[i]));
    const availableCandidate = candidates.find(v => v.available);
    const candidate = availableCandidate || candidates[0] || variants.find(v => v.options[pos] === value);
    const unavailable = !availableCandidate;
    choice.classList.toggle('is-unavailable', unavailable);
    choice.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    const priceEl = choice.querySelector('[data-v23-option-price]');
    if (priceEl && candidate) priceEl.textContent = burstFormatMoney(candidate.price, moneyFormat);
  });

  formWrap.querySelectorAll('[data-v23-option-current]').forEach(label => {
    const pos = Math.max(0, Number(label.dataset.v23OptionCurrent || 1) - 1);
    label.textContent = selected[pos] || '';
  });
}

function burstUpdateVariant(formWrap) {
  const json = formWrap?.querySelector('[data-variants-json]');
  const idInput = formWrap?.querySelector('[data-variant-id]');
  if (!json || !idInput) return null;

  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return null; }

  const groups = Array.from(formWrap.querySelectorAll('[data-option-group]'));
  const selected = groups.map(group => group.querySelector('[data-option-input]:checked')?.value);
  const match = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
  if (!match) return null;

  idInput.value = match.id;
  const moneyFormat = formWrap.dataset.moneyFormat || '${{amount}}';
  burstSyncGroupedOptionPicker(formWrap, variants, selected, moneyFormat);
  const price = formWrap.querySelector('[data-price]');
  const compare = formWrap.querySelector('[data-compare]');
  const addButton = formWrap.querySelector('[data-main-add]');
  const addText = formWrap.querySelector('[data-add-text]');
  const sticky = document.querySelector('[data-sticky-cart]');
  const stickyPrice = sticky?.querySelector('[data-sticky-price]');
  const stickyVariant = sticky?.querySelector('[data-sticky-variant]');
  const stickyImage = sticky?.querySelector('[data-sticky-image]');
  const stickyButton = sticky?.querySelector('[data-sticky-add]');
  const stickyText = sticky?.querySelector('[data-sticky-add-text]');

  if (price) price.textContent = burstFormatMoney(match.price, moneyFormat);
  if (compare) {
    compare.textContent = match.compare_at_price ? burstFormatMoney(match.compare_at_price, moneyFormat) : '';
    compare.style.display = match.compare_at_price ? '' : 'none';
  }
  if (stickyPrice) stickyPrice.textContent = burstFormatMoney(match.price, moneyFormat);
  if (stickyVariant) stickyVariant.textContent = match.title === 'Default Title' ? '' : match.title;

  // Media is resolved separately from the exact purchasable variant.
  // This keeps Color -> image linkage working even when S/M/L variants share one color image.
  const mediaVariant = burstCowMediaForStyle(formWrap, match) || burstResolveVariantForMedia(formWrap, variants, match);
  const imageSrc = burstVariantImage(mediaVariant);
  if (imageSrc) {
    if (stickyImage) stickyImage.src = imageSrc;
    const mainImage = document.querySelector('[data-main-image]');
    if (mainImage) {
      mainImage.src = imageSrc;
      mainImage.srcset = '';
    }
  }
  burstSwitchV23GalleryToVariant(mediaVariant, true);

  const available = Boolean(match.available);
  if (addButton) addButton.disabled = !available;
  if (stickyButton) stickyButton.disabled = !available;
  if (addText) addText.textContent = available ? (addText.dataset.availableText || 'ADD TO CART') : 'Sold out';
  if (stickyText) stickyText.textContent = available ? (stickyText.dataset.availableText || 'ADD TO CART') : 'Sold out';

  document.querySelectorAll('[data-v23-variant-card]').forEach(card => {
    card.classList.toggle('is-selected', String(card.dataset.variantId) === String(match.id));
  });
  const currentVariantLabel = document.querySelector('[data-v23-current-variant]');
  if (currentVariantLabel) currentVariantLabel.textContent = match.title || '';

  const url = new URL(window.location.href);
  url.searchParams.set('variant', match.id);
  window.history.replaceState({}, '', url.toString());
  return match;
}

document.addEventListener('click', (e) => {
  const optionChoice = e.target.closest('[data-v23-option-choice]');
  if (!optionChoice) return;
  e.preventDefault();
  if (optionChoice.classList.contains('is-unavailable')) return;
  const formWrap = optionChoice.closest('[data-product-form-wrap]');
  const pos = optionChoice.dataset.optionPosition;
  const value = optionChoice.dataset.optionValue;
  const group = formWrap?.querySelector(`[data-option-group] input[data-option-input][name="option-${pos}"]` )?.closest('[data-option-group]');
  const inputs = group ? Array.from(group.querySelectorAll('[data-option-input]')) : [];
  const input = inputs.find(el => el.value === value);
  if (!input) return;
  input.checked = true;
  burstUpdateVariant(formWrap);
  burstHHShowOptionImage(optionChoice);
});

document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery?.querySelector('[data-main-image]');
    if (main && thumb.dataset.src) {
      main.src = thumb.dataset.src;
      main.srcset = '';
      gallery.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }

  const qbtn = e.target.closest('[data-qty]');
  if (qbtn) {
    const input = qbtn.parentElement.querySelector('input');
    const next = Math.max(1, parseInt(input.value || '1', 10) + (qbtn.dataset.qty === 'plus' ? 1 : -1));
    input.value = next;
  }

  const stickyAdd = e.target.closest('[data-sticky-add]');
  if (stickyAdd) {
    const form = document.querySelector('#BurstMainProductForm');
    const mainAdd = form?.querySelector('[data-main-add]');
    if (form && mainAdd && !mainAdd.disabled) mainAdd.click();
  }
});

document.addEventListener('change', (e) => {
  if (!e.target.matches('[data-option-input]')) return;
  const formWrap = e.target.closest('[data-product-form-wrap]');
  burstUpdateVariant(formWrap);
  const selectedChoice = formWrap?.querySelector(`[data-v23-option-choice][data-option-position="${e.target.name.replace('option-','')}"][data-option-value="${CSS.escape(e.target.value)}"]`);
  burstHHShowOptionImage(selectedChoice);
});

document.addEventListener('DOMContentLoaded', () => {
  const formWrap = document.querySelector('[data-product-form-wrap]');
  const mainAdd = formWrap?.querySelector('[data-main-add]');
  const stickyText = document.querySelector('[data-sticky-add-text]');
  const addText = formWrap?.querySelector('[data-add-text]');
  if (addText) addText.dataset.availableText = addText.textContent.trim() || 'ADD TO CART';
  if (stickyText) stickyText.dataset.availableText = stickyText.textContent.trim() || 'ADD TO CART';

  if (formWrap) {
    burstUpdateVariant(formWrap);
    const initialStyle = formWrap.querySelector('[data-v23-option-choice][data-option-position="1"].is-selected[data-hh-image-url]');
    burstHHShowOptionImage(initialStyle);
  }

  const sticky = document.querySelector('[data-sticky-cart]');
  const mainSection = document.querySelector('[data-main-product-section]');
  if (sticky && mainSection && mainAdd) {
    const updateSticky = () => {
      const rect = mainAdd.getBoundingClientRect();
      const shouldShow = rect.bottom < 0;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-cart', shouldShow);
    };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
  }
});

// Burst V1.2 localization selectors, cart quantity controls and session reservation timer
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-localization-select]')) e.target.form?.submit();
});
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-cart-qty]');
  if (!btn) return;
  const wrap = btn.closest('.cart-qty');
  const input = wrap?.querySelector('input');
  if (!input) return;
  input.value = Math.max(0, parseInt(input.value || '0', 10) + (btn.dataset.cartQty === 'plus' ? 1 : -1));
  input.form?.submit();
});


// Burst V2.2.1 — global free-shipping baseline: USD $39.99.
// Shopify Markets provides the active presentment currency. Shopify.currency.rate
// converts the USD baseline into the customer's active storefront currency.
function burstGlobalFreeShippingThreshold(baseCents) {
  const rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  return Math.max(1, Math.round(Number(baseCents || 3999) * rate));
}

function burstUpdateCartPageShippingProgress() {
  const cart = document.querySelector('[data-cart-section]');
  const progress = cart?.querySelector('[data-cart-shipping-progress]');
  if (!cart || !progress) return;
  const total = Number(cart.dataset.cartTotal || 0);
  const threshold = burstGlobalFreeShippingThreshold(Number(cart.dataset.freeShippingUsd || 3999));
  const left = Math.max(0, threshold - total);
  const pct = Math.min(100, total * 100 / threshold);
  const msg = progress.querySelector('[data-cart-shipping-message]');
  const bar = progress.querySelector('[data-cart-shipping-bar]');
  if (bar) bar.style.width = pct + '%';
  if (msg) msg.textContent = left <= 0
    ? "✓ You've unlocked FREE SHIPPING!"
    : "You're only " + burstStableFormatMoney(left, cart.dataset.moneyFormat || '') + " away from FREE SHIPPING";
}

document.addEventListener('DOMContentLoaded', () => {
  const cart = document.querySelector('[data-cart-section]');
  const timer = cart?.querySelector('[data-cart-timer]');
  burstUpdateCartPageShippingProgress();
  if (cart && timer) {
    const mins = Math.max(1, parseInt(cart.dataset.reserveMinutes || '10', 10));
    const key = 'burstCartReserveUntil';
    let until = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!until || until < Date.now()) { until = Date.now() + mins * 60000; sessionStorage.setItem(key, String(until)); }
    const tick = () => { const left = Math.max(0, until - Date.now()); const m = Math.floor(left/60000); const s = Math.floor((left%60000)/1000); timer.textContent = String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0'); if (left > 0) setTimeout(tick,1000); };
    tick();
  }
});

// Burst V1.3 — tap sticky thumbnail to switch product variant
function burstStickyVariantPicker(open) {
  const picker = document.querySelector('[data-sticky-variant-picker]');
  if (!picker) return;
  picker.classList.toggle('is-open', open);
  picker.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('sticky-variant-picker-open', open);
}

function burstSelectVariantById(variantId) {
  const formWrap = document.querySelector('[data-product-form-wrap]');
  const json = formWrap?.querySelector('[data-variants-json]');
  if (!formWrap || !json) return;
  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  const variant = variants.find(v => String(v.id) === String(variantId));
  if (!variant) return;

  const groups = Array.from(formWrap.querySelectorAll('[data-option-group]'));
  groups.forEach((group, index) => {
    const wanted = variant.options[index];
    const inputs = Array.from(group.querySelectorAll('[data-option-input]'));
    const input = inputs.find(el => el.value === wanted);
    if (input) input.checked = true;
  });
  const selected = burstUpdateVariant(formWrap);
  if (!selected) return;

  document.querySelectorAll('[data-sticky-variant-choice]').forEach(card => {
    card.classList.toggle('is-selected', String(card.dataset.variantId) === String(selected.id));
  });

  // Keep the visual variant picker in sync no matter where the variant is changed.
  document.querySelectorAll('[data-v23-variant-card]').forEach(card => {
    card.classList.toggle('is-selected', String(card.dataset.variantId) === String(selected.id));
  });
  const currentVariantLabel = document.querySelector('[data-v23-current-variant]');
  if (currentVariantLabel) currentVariantLabel.textContent = selected.title || '';

  burstStickyVariantPicker(false);
  return selected;
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-sticky-variant-open]')) {
    e.preventDefault();
    burstStickyVariantPicker(true);
    return;
  }
  if (e.target.closest('[data-sticky-variant-close]')) {
    e.preventDefault();
    burstStickyVariantPicker(false);
    return;
  }
  const choice = e.target.closest('[data-sticky-variant-choice]');
  if (choice) {
    e.preventDefault();
    burstSelectVariantById(choice.dataset.variantId);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') burstStickyVariantPicker(false);
});


// ================= BURST V2.0.1 STABLE ADD-ONS =================
function burstStableFormatMoney(cents, format) {
  if (typeof burstFormatMoney === 'function') return burstFormatMoney(cents, format);
  try {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format((cents||0)/100);
  } catch(e) { return ((cents||0)/100).toFixed(2); }
}

function burstStableDate(days) {
  const d = new Date();
  d.setHours(12,0,0,0);
  d.setDate(d.getDate() + Number(days || 0));
  try {
    return new Intl.DateTimeFormat(document.documentElement.lang || navigator.language || 'en', {
      month:'short', day:'numeric'
    }).format(d);
  } catch(e) {
    return d.toLocaleDateString();
  }
}

function burstStableRenderEta() {
  document.querySelectorAll('[data-stable-delivery]').forEach(el => {
    const sm = Number(el.dataset.standardMin || 7);
    const sx = Number(el.dataset.standardMax || 12);
    const em = Number(el.dataset.expressMin || 3);
    const ex = Number(el.dataset.expressMax || 7);
    const s = el.querySelector('[data-standard-eta]');
    const x = el.querySelector('[data-express-eta]');
    if (s) s.textContent = burstStableDate(sm) + ' – ' + burstStableDate(sx);
    if (x) x.textContent = burstStableDate(em) + ' – ' + burstStableDate(ex);
  });
}

function burstStableDrawer(open) {
  const el = document.querySelector('[data-stable-cart-drawer]');
  if (!el) return;
  el.classList.toggle('is-open', !!open);
  el.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('stable-cart-open', !!open);
}

async function burstStableGetCart() {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const r = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});
  if (!r.ok) throw new Error('Cart request failed');
  return r.json();
}

function burstStableEscape(s='') {
  return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
}

async function burstStableRenderCart(openAfter) {
  const drawer = document.querySelector('[data-stable-cart-drawer]');
  if (!drawer) return;
  const body = drawer.querySelector('[data-stable-cart-body]');
  try {
    const cart = await burstStableGetCart();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const moneyFormat = document.querySelector('[data-product-form-wrap]')?.dataset.moneyFormat || '';
    const subtotal = drawer.querySelector('[data-stable-cart-subtotal]');
    if (subtotal) subtotal.textContent = burstStableFormatMoney(cart.total_price, moneyFormat);

    if (!cart.items.length) {
      body.innerHTML = '<div class="stable-cart-empty">Your cart is empty.</div>';
    } else {
      body.innerHTML = cart.items.map((item, idx) => `
        <article class="stable-cart-item">
          <a href="${burstStableEscape(item.url)}">
            <img src="${burstStableEscape(item.image || '')}" alt="${burstStableEscape(item.product_title || '')}">
          </a>
          <div class="stable-cart-item__info">
            <a href="${burstStableEscape(item.url)}"><strong>${burstStableEscape(item.product_title || '')}</strong></a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${burstStableEscape(item.variant_title)}</span>` : ''}
            <div class="stable-cart-item__bottom">
              <div class="stable-cart-qty">
                <button type="button" data-stable-line="${idx+1}" data-stable-delta="-1">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-stable-line="${idx+1}" data-stable-delta="1">+</button>
              </div>
              <b>${burstStableFormatMoney(item.final_line_price, moneyFormat)}</b>
            </div>
            <button type="button" class="stable-cart-remove" data-stable-remove="${idx+1}">Remove</button>
          </div>
        </article>`).join('');
    }

    const prog = drawer.querySelector('[data-stable-shipping-progress]');
    if (prog) {
      const threshold = burstGlobalFreeShippingThreshold(Number(prog.dataset.thresholdUsd || 3999));
      const msg = prog.querySelector('[data-stable-shipping-message]');
      const bar = prog.querySelector('[data-stable-progress-bar]');
      if (threshold > 0) {
        const left = Math.max(0, threshold - cart.total_price);
        const pct = Math.min(100, cart.total_price * 100 / threshold);
        if (bar) bar.style.width = pct + '%';
        if (msg) msg.textContent = left <= 0 ? '✓ Free shipping unlocked' : burstStableFormatMoney(left, moneyFormat) + ' away from free shipping';
      }
    }

    if (openAfter) burstStableDrawer(true);
  } catch(e) {
    body.innerHTML = '<div class="stable-cart-empty">Cart unavailable. Please open the cart page.</div>';
  }
}

async function burstStableChange(line, qty) {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  await fetch(root + 'cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({line, quantity:qty})
  });
  await burstStableRenderCart(false);
}

document.addEventListener('click', async (e) => {
  if (e.target.closest('[data-stable-cart-close]')) {
    e.preventDefault(); burstStableDrawer(false); return;
  }

  // Works with explicit stable trigger OR normal cart link/button if user chooses to add trigger later.
  const open = e.target.closest('[data-stable-cart-open]');
  if (open) {
    e.preventDefault(); await burstStableRenderCart(true); return;
  }

  const q = e.target.closest('[data-stable-line]');
  if (q) {
    e.preventDefault();
    const cart = await burstStableGetCart();
    const line = Number(q.dataset.stableLine);
    const item = cart.items[line-1];
    if (item) await burstStableChange(line, Math.max(0, item.quantity + Number(q.dataset.stableDelta || 0)));
    return;
  }

  const rem = e.target.closest('[data-stable-remove]');
  if (rem) {
    e.preventDefault();
    await burstStableChange(Number(rem.dataset.stableRemove), 0);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  burstStableRenderEta();
  burstStableRenderCart(false).catch(()=>{});
});


// ================= V2.1 RECENTLY VIEWED =================
(function(){
  const key = 'burst_recent_products_v21';

  function storeCurrentProduct() {
    const section = document.querySelector('[data-recently-viewed-section]');
    if (!section) return;
    const handle = section.dataset.currentHandle;
    if (!handle) return;
    let arr = [];
    try { arr = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) {}
    arr = arr.filter(h => h !== handle);
    arr.unshift(handle);
    localStorage.setItem(key, JSON.stringify(arr.slice(0, 8)));
  }

  async function renderRecentlyViewed() {
    const section = document.querySelector('[data-recently-viewed-section]');
    if (!section) return;
    const current = section.dataset.currentHandle;
    const limit = Number(section.dataset.limit || 4);
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) {}
    handles = handles.filter(h => h && h !== current).slice(0, limit);
    if (!handles.length) { storeCurrentProduct(); return; }

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const results = await Promise.all(handles.map(async handle => {
      try {
        const r = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {headers:{'Accept':'application/json'}});
        return r.ok ? await r.json() : null;
      } catch(e) { return null; }
    }));

    const grid = section.querySelector('[data-recently-viewed-grid]');
    const content = section.querySelector('[data-recently-viewed-content]');
    const products = results.filter(Boolean);
    if (products.length && grid && content) {
      grid.innerHTML = products.map(p => {
        const image = p.featured_image || (p.images && p.images[0]) || '';
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        let price = '';
        try { price = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format((p.price||0)/100); } catch(e) { price = ((p.price||0)/100).toFixed(2); }
        return `<article class="ms-product-card"><a href="${root}products/${encodeURIComponent(p.handle)}">${image ? `<img src="${image}" alt="${String(p.title||'').replace(/"/g,'&quot;')}" loading="lazy">` : ''}<div class="ms-product-card__copy"><strong>${p.title}</strong><span>${price}</span></div></a></article>`;
      }).join('');
      content.hidden = false;
    }
    storeCurrentProduct();
  }

  document.addEventListener('DOMContentLoaded', () => { renderRecentlyViewed().catch(storeCurrentProduct); });
})();


// ================= V2.3 PDP UPGRADE =================
(function(){
  function v23Gallery(){
    const gallery = document.querySelector('[data-v23-gallery]');
    if (!gallery) return null;
    const track = gallery.querySelector('[data-v23-mobile-track]');
    const slides = [...gallery.querySelectorAll('[data-v23-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-v23-thumb]')];
    const dots = [...gallery.querySelectorAll('[data-v23-dot]')];

    function setActiveById(id, scrollMobile=true){
      const slide = slides.find(s => String(s.dataset.v23Slide) === String(id));
      if (!slide) return;

      slides.forEach(s => s.classList.toggle('is-active', s === slide));
      thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.v23Thumb) === String(id)));
      dots.forEach(d => d.classList.toggle('is-active', String(d.dataset.v23Dot) === String(id)));

      if (window.innerWidth < 750 && scrollMobile && track) {
        track.scrollTo({left: slide.offsetLeft, behavior:'smooth'});
      }
    }

    function currentIndex(){
      const active = dots.findIndex(d => d.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    }

    gallery.addEventListener('click', e => {
      const thumb = e.target.closest('[data-v23-thumb]');
      if (thumb) {
        e.preventDefault();
        setActiveById(thumb.dataset.v23Thumb, false);
      }

      const dot = e.target.closest('[data-v23-dot]');
      if (dot) {
        e.preventDefault();
        setActiveById(dot.dataset.v23Dot, true);
      }

      if (e.target.closest('[data-v23-prev]')) {
        e.preventDefault();
        const i = (currentIndex() - 1 + slides.length) % slides.length;
        setActiveById(slides[i].dataset.v23Slide, false);
      }

      if (e.target.closest('[data-v23-next]')) {
        e.preventDefault();
        const i = (currentIndex() + 1) % slides.length;
        setActiveById(slides[i].dataset.v23Slide, false);
      }
    });

    if (track) {
      let timer;
      track.addEventListener('scroll', () => {
        if (window.innerWidth >= 750) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          const idx = Math.round(track.scrollLeft / Math.max(track.clientWidth,1));
          const slide = slides[Math.max(0, Math.min(slides.length - 1, idx))];
          if (slide) {
            thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.v23Thumb) === String(slide.dataset.v23Slide)));
            dots.forEach(d => d.classList.toggle('is-active', String(d.dataset.v23Dot) === String(slide.dataset.v23Slide)));
          }
        }, 60);
      }, {passive:true});
    }

    return {setActiveById};
  }

  let galleryApi;

  function selectVariantCard(card){
    if (!card || card.classList.contains('is-sold-out')) return;
    const id = card.dataset.variantId;
    if (!id) return;

    if (typeof burstSelectVariantById === 'function') {
      const variant = burstSelectVariantById(id);
      document.querySelectorAll('[data-v23-variant-card]').forEach(c => {
        c.classList.toggle('is-selected', String(c.dataset.variantId) === String(id));
      });
      const current = document.querySelector('[data-v23-current-variant]');
      if (current && variant) current.textContent = variant.title || '';
      if (variant && variant.featured_media && variant.featured_media.id && galleryApi) {
        galleryApi.setActiveById(variant.featured_media.id, true);
      } else if (variant && variant.featured_image && galleryApi) {
        // Existing Shopify variant JSON sometimes exposes featured_media instead of featured_image ids.
        const matching = [...document.querySelectorAll('[data-v23-slide]')].find(s => {
          const img = s.querySelector('img');
          return img && variant.featured_image.src && img.src.includes(variant.featured_image.src.split('?')[0]);
        });
        if (matching) galleryApi.setActiveById(matching.dataset.v23Slide, true);
      }
    }
  }

  function lightboxInit(){
    const lb = document.querySelector('[data-v23-lightbox]');
    if (!lb) return;
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-v23-zoom-trigger]');
      if (trigger && window.innerWidth >= 750) {
        const img = trigger.querySelector('img');
        if (img) {
          lb.querySelector('[data-v23-lightbox-image]').src = img.currentSrc || img.src;
          lb.classList.add('is-open');
          lb.setAttribute('aria-hidden','false');
          document.body.style.overflow='hidden';
        }
      }
      if (e.target.closest('[data-v23-lightbox-close]') || e.target === lb) {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden','true');
        document.body.style.overflow='';
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden','true');
        document.body.style.overflow='';
      }
    });
  }

  document.addEventListener('click', e => {
    const card = e.target.closest('[data-v23-variant-card]');
    if (card) {
      e.preventDefault();
      selectVariantCard(card);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    galleryApi = v23Gallery();
    lightboxInit();
  });
})();

// V2.6.12: Initial gallery image must follow Style, even if Shopify variant featured image is outfit.
document.addEventListener('DOMContentLoaded', () => {
 const gallery = document.querySelector('[data-hh-cow-gallery]');
 const form = document.querySelector('[data-variants-json]')?.closest('form, [data-product-form]');
 if (!gallery || !form) return;
 try {
  const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
  const id = form.querySelector('[data-variant-id]')?.value;
  const v = variants.find(x => String(x.id) === String(id)) || variants[0];
  const media = burstCowMediaForStyle(form,v);
  if (media) burstSwitchV23GalleryToVariant(media,false);
 } catch(e) { /* retain theme fallback */ }
});
